import { render, staticRenderFns } from "./ChatMedia.vue?vue&type=template&id=4ec32916"
import script from "./ChatMedia.vue?vue&type=script&lang=js"
export * from "./ChatMedia.vue?vue&type=script&lang=js"
import style0 from "./ChatMedia.vue?vue&type=style&index=0&id=4ec32916&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports